import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, Users } from "lucide-react";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";

export function Avatar({ user, size = "w-9 h-9" }) {
  const initials = (user.name || "?").split(" ").map(s => s[0]).join("").slice(0, 2).toUpperCase();
  return user.picture
    ? <img src={user.picture} alt="" className={`${size} object-cover border border-foreground`} referrerPolicy="no-referrer" />
    : <span className={`${size} inline-flex items-center justify-center border border-foreground bg-secondary text-secondary-foreground font-display text-sm`}>{initials}</span>;
}

export default function AttendeesModal({ eventId, onClose }) {
  const { t } = useApp();
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(true);

  const load = async (skip = 0) => {
    setBusy(true);
    const { data: d } = await api.get(`/events/${eventId}/attendees`, { params: { skip, limit: 30 } });
    setData(prev => skip && prev ? { ...d, items: [...prev.items, ...d.items] } : d);
    setBusy(false);
  };
  useEffect(() => { load(0); }, [eventId]); // eslint-disable-line

  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-end sm:items-center justify-center" onClick={onClose} data-testid="attendees-modal">
      <div onClick={e => e.stopPropagation()} className="gg-card bg-background w-full sm:max-w-md max-h-[85vh] flex flex-col">
        <div className="flex items-center justify-between p-4 border-b border-foreground">
          <h3 className="font-display uppercase text-xl flex items-center gap-2" data-testid="attendees-title">
            <Users className="w-5 h-5 text-primary" />{!data ? "…" : data.count === 1 ? t("onePersonGoing") : t("peopleGoing", { n: data.count })}
          </h3>
          <button onClick={onClose} className="gg-icon-btn" aria-label={t("cancel")} data-testid="attendees-close"><X className="w-5 h-5" /></button>
        </div>
        <ul className="overflow-y-auto divide-y divide-foreground" data-testid="attendees-list">
          {(data?.items || []).map(u => (
            <li key={u.user_id}>
              <Link to={`/users/${u.user_id}`} onClick={onClose} className="flex items-center gap-3 p-3 hover:bg-muted transition-colors" data-testid={`attendee-${u.user_id}`}>
                <Avatar user={u} /><span className="min-w-0"><span className="block font-display text-base leading-tight">{u.name}</span>{u.location && <span className="block text-xs text-muted-foreground">{u.location}</span>}</span>
              </Link>
            </li>
          ))}
          {!busy && data && data.items.length === 0 && <li className="p-6 text-center text-sm text-muted-foreground">{t("nobodyGoingYet")}</li>}
        </ul>
        {data?.has_more && (
          <div className="p-3 border-t border-foreground">
            <button disabled={busy} onClick={() => load(data.items.length)} className="gg-btn w-full" data-testid="attendees-load-more">{busy ? "…" : t("loadMore")}</button>
          </div>
        )}
      </div>
    </div>
  );
}
